import styled from "styled-components";

export const PropertiesContainer = styled.div`
  display: flex;
  height: calc(100% - 40px - 15px);
  width: 100%;
`;
